exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] .JTTi0WstRi2rRRH3PC8K9{margin:8px 0}html[dir] .JTTi0WstRi2rRRH3PC8K9:last-child{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"root": "JTTi0WstRi2rRRH3PC8K9"
};